module.exports = __webpack_public_path__ + "img/00043.92c2806c.webp";